{
  "enum": {
    "IxcCorpactionsV1ActionType": {
      "DIVIDEND": "Dividend",
      "MERGER": "Merger",
      "REVERSE_STOCK_SPLIT": "Reverse Stock Split",
      "SPINOFF": "Spinoff",
      "STOCK_DIVIDEND": "Stock Dividend",
      "STOCK_SPLIT": "Stock Split",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCorpactionsV1DeferredStatus": {
      "KNOWN": "Known",
      "PAID": "Paid",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCorpactionsV1PaymentType": {
      "DIVIDEND": "Dividend",
      "REORG": "Reorg",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCorpactionsV1RoundingMethod": {
      "ALWAYS_DOWN": "Always Down",
      "ALWAYS_UP": "Always Up",
      "HALF_UP": "Half Up",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "oneOf": {
    "IxcCorpactionsV1CostCalculationType": {
      "cashToBoot": "Cash to Boot",
      "costTransfer": "Cost Transfer",
      "fixedRate": "Fixed Rate",
      "noCostTransfer": "No Cost Transfer",
      "quantityAdjustment": "Quantity Adjustment"
    },
    "IxcCorpactionsV1CustomerAssignment": {
      "cashInLieu": "Cash in Lieu",
      "main": "Main"
    }
  }
}